(function (factory) {
    typeof define === 'function' && define.amd ? define(factory) :
    factory();
}((function () { 'use strict';

    var Header = {
        init: function init()
        {
            // Your code to run since DOM is loaded and ready
            /* Variables */
            var body = document.getElementsByTagName('body')[0];
            var menuBurger = document.getElementsByClassName('menu-burger');
            var menuBurgerSvg = document.getElementsByClassName('menu-burger-svg');
            var menuBurgerMobile = document.getElementById('mobile-menu');
            var menuBurgerMobileSvg = document.getElementById('mobile-menu-icon');
            var menuBurgerMobileImg = document.getElementById('menu-mobile-image');
            var menuContainer = document.getElementById('menu-header-container');
            var menuTitle = document.getElementsByClassName('menu-title');
            var blackHeader = document.getElementById('black-header');
            var whiteHeader = document.getElementById('white-header');
            var hybridHeader = document.getElementById('hybrid-header');
            var svgLogoOnPage = document.getElementsByClassName('svg-logo-desktop')[0];
            var wineFooter = document.getElementsByClassName('wine-footer')[0];
            var positionY = window.scrollY;
            var isMobile = {
                Android: function () {
                    return navigator.userAgent.match(/Android/i);
                },
                BlackBerry: function () {
                    return navigator.userAgent.match(/BlackBerry/i);
                },
                iPhone: function () {
                    return navigator.userAgent.match(/iPhone|iPod/i);
                },
                iPad: function () {
                    return navigator.userAgent.match(/iPad/i);
                },
                Opera: function () {
                    return navigator.userAgent.match(/Opera Mini/i);
                },
                Windows: function () {
                    return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
                },
                any: function () {
                    return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iPhone() || isMobile.Opera() || isMobile.Windows());
                }
            };

            /* MENU ACTIVE ITEM */
            var fullUrl = window.location.href;
            var url = fullUrl.split('/')[3];
            var item;
            if (url === '/'){
                item = document.querySelector('.elementor-item[href="' + fullUrl + '"]');
            }else {
                item = document.querySelector('.elementor-item[href*="' + url + '"]');
                if (!item){
                    item = document.querySelector('.elementor-sub-item[href*="' + url + '"]');
                }
            }
            if (item){
                item.setAttribute('style', 'font-family: \'fakt pro\', sans-serif; font-weight: 600;');
                var itemsAnchors = document.getElementsByClassName('elementor-item-anchor');
                var loop = function ( ia ) {
                    itemsAnchors[ia].addEventListener('click', function(){
                        itemsAnchors[ia].setAttribute('style', 'font-family: \'fakt pro\', sans-serif; font-weight: 600;');
                        for (var ia2 = 0; ia2 < itemsAnchors.length; ia2++){
                            if (itemsAnchors[ia2] !== itemsAnchors[ia]) {
                                itemsAnchors[ia2].removeAttribute('style');
                            }
                        }
                        item.removeAttribute('style');
                    });
                };

                for (var ia = 0; ia < itemsAnchors.length; ia++)loop( ia );
            }
            /* HEADER CHANGING COLOR WHEN SCROLLING */
            function blackHeaderDisplay() {
                blackHeader.style.display = 'block';
                hybridHeader.style.display = 'none';
                whiteHeader.style.display = 'none';
                blackHeader.style.width = '100%';
                blackHeader.style.position = 'fixed';
                blackHeader.style.top = '0';
            }
            function whiteHeaderDisplay() {
                blackHeader.style.display = 'none';
                hybridHeader.style.display = 'none';
                whiteHeader.style.display = 'block';
                whiteHeader.style.width = '100%';
                whiteHeader.style.position = 'fixed';
                whiteHeader.style.top = '0';
            }
            function hybridHeaderDisplay() {
                blackHeader.style.display = 'none';
                whiteHeader.style.display = 'none';
                hybridHeader.style.display = 'block';
                hybridHeader.style.width = '100%';
                hybridHeader.style.position = 'fixed';
                hybridHeader.style.top = '0';
            }
            function checkWhichHeaderNeeded(position, menu){
                if (!isMobile.any() || (window.innerWidth > window.innerHeight)) {
                    if (position >= 0 && !menu.classList.contains('show') && body.classList.contains('home')) {
                        if (position >= 755) {
                            blackHeaderDisplay();
                        } else {
                            whiteHeaderDisplay();
                        }
                    } else if (!menu.classList.contains('show') && !body.classList.contains('home')) {
                        blackHeaderDisplay();
                    } else {
                        if ((body.classList.contains('post-type-archive-restaurant') || body.classList.contains('restaurant-template-default') || body.classList.contains('page-template-default') || body.classList.contains('presse-template-default'))  && !body.classList.contains('home')){
                            hybridHeaderDisplay();
                        }else {
                            whiteHeaderDisplay();
                        }
                    }
                }
            }
            checkWhichHeaderNeeded(positionY, menuContainer);
            window.addEventListener('scroll', function () {
                if (!isMobile.any() || (window.innerWidth > window.innerHeight)){
                    positionY = window.scrollY;
                    checkWhichHeaderNeeded(positionY, menuContainer);
                }
            });
            /* MENU */
            function toggleMenu(){
                for (var j = 0; j < menuBurger.length; j++) {
                    var svg = menuBurgerSvg[j].getElementsByTagName('svg')[0];
                    if (svg.classList.contains('rotate-menu')) {
                        svg.classList.remove('rotate-menu');
                        svg.classList.add('rotate-menu-back');
                        menuContainer.classList.remove('show');
                        menuContainer.classList.add('hide');
                        setTimeout(function () {menuContainer.classList.remove('hide');}, 500);
                        menuTitle[j].classList.remove('hide');
                    } else if (svg.classList.contains('rotate-menu-back')) {
                        svg.classList.remove('rotate-menu-back');
                        svg.classList.add('rotate-menu');
                        menuContainer.classList.remove('hide');
                        menuContainer.classList.add('show');
                        menuTitle[j].classList.add('hide');
                    } else {
                        svg.classList.add('rotate-menu');
                        menuContainer.classList.remove('hide');
                        menuContainer.classList.add('show');
                        menuTitle[j].classList.add('hide');
                    }
                }
                if(svgLogoOnPage){
                    if (svgLogoOnPage.hasAttribute('style')){
                        svgLogoOnPage.removeAttribute('style');
                    }else {
                        svgLogoOnPage.style.display = 'none';
                    }
                }
                if(wineFooter){
                    if (wineFooter.hasAttribute('style')){
                        wineFooter.removeAttribute('style');
                    }else {
                        wineFooter.style.display = 'none';
                    }
                }
                checkWhichHeaderNeeded(positionY, menuContainer);
            }
            for (var i = 0; i < menuBurger.length; i++) {
                menuBurger[i].addEventListener('click', function() {
                    toggleMenu();
                });
            }
            function toggleBurgerMenu(){
                var svg = menuBurgerMobileSvg.getElementsByTagName('svg')[0];
                if (svg.classList.contains('rotate-menu')) {
                    svg.classList.remove('rotate-menu');
                    svg.classList.add('rotate-menu-back');
                    menuContainer.classList.remove('show');
                    menuBurgerMobile.style.background = 'white';
                    svg.style.filter = "invert(0%) sepia(100%) saturate(0%) hue-rotate(280deg) brightness(0%) contrast(100%)";
                    menuBurgerMobileImg.style.display = 'block';
                } else if (svg.classList.contains('rotate-menu-back')) {
                    svg.classList.remove('rotate-menu-back');
                    svg.classList.add('rotate-menu');
                    menuContainer.classList.add('show');
                    menuBurgerMobile.style.background = 'none';
                    svg.style.filter = "none";
                    menuBurgerMobileImg.style.display = 'none';
                } else {
                    svg.classList.add('rotate-menu');
                    menuContainer.classList.add('show');
                    menuBurgerMobile.style.background = 'none';
                    svg.style.filter = "none";
                    menuBurgerMobileImg.style.display = 'none';
                }
                if(svgLogoOnPage){
                    if (svgLogoOnPage.hasAttribute('style')){
                        svgLogoOnPage.removeAttribute('style');
                    }else {
                        svgLogoOnPage.style.display = 'none';
                    }
                }
                if(wineFooter){
                    if (wineFooter.hasAttribute('style')){
                        wineFooter.removeAttribute('style');
                    }else {
                        wineFooter.style.display = 'none';
                    }
                }
            }
            /* MENU MOBILE*/
            menuBurgerMobile.addEventListener('click', function() {
                toggleBurgerMenu();
            });

            document.addEventListener('click', function(event) {
                var isClickInside = menuContainer.contains(event.target);
                var isIpad = isMobile.iPad();
                var element = event.target.closest('.elementor-element');
                if (((!isIpad && !isClickInside && event.target.tagName !== 'svg' && element === null) || (!isIpad && !isClickInside && event.target.tagName !== 'svg' && element && element.getAttribute('id') !== 'logo-header-black' && element.getAttribute('id') !== 'logo-header-white' && !element.classList.contains('menu-title') && !element.classList.contains('menu-column')) || event.target.classList.contains('elementor-item-anchor')) || event.target.classList.contains('elementor-item-anchor')){
                    if (isMobile.any() || window.innerWidth <= 767 ){
                        if (menuContainer.classList.contains('show')){
                            toggleBurgerMenu();
                        }
                    }else if (isMobile.iPad()){
                        if (menuContainer.classList.contains('show')){
                            toggleMenu();
                        }
                    }else {
                        if (menuContainer.classList.contains('show')){
                            toggleMenu();
                        }
                    }
                }
            });

            /* PRESS HOME */
            if (body.classList.contains('home')) {
                var displayPressContainer = document.getElementsByClassName('display-press-container')[0];
                var pressItems = document.getElementsByClassName('item-press');
                var position = 1;
                for (var p = 0; p < pressItems.length; p++){
                    var col = (void 0);
                    if (p === 6){
                        var displayPressContainerNew = document.createElement('div');
                        displayPressContainerNew.classList.add('display-press-container');
                        displayPressContainer.after(displayPressContainerNew);
                        displayPressContainer = displayPressContainerNew;
                    }
                    if (position === 1 || position === 4){
                        col = document.createElement('div');
                        col.classList.add('double-col');
                        col.setAttribute('id', 'double-col-' + p);
                        col.innerHTML = pressItems[p].innerHTML;
                        displayPressContainer.append(col);
                    }
                    if (position === 2 || position === 5){
                        col = document.getElementById('double-col-' + (p - 1));
                        col.innerHTML += pressItems[p].innerHTML;
                    }
                    if (position === 3 || position === 6){
                        col = document.createElement('div');
                        col.classList.add('unique-col');
                        col.setAttribute('id', 'unique-col-' + p);
                        col.innerHTML = pressItems[p].innerHTML;
                        displayPressContainer.append(col);
                    }
                    if (position === 6){
                        position = 1;
                    }else {
                        position++;
                    }
                }
                var pressImgItems = document.querySelectorAll('.display-press-container img');
                for (var v = 0; v < pressImgItems.length; v++){
                    pressImgItems[v].addEventListener('click', function(event) {
                        window.location.href = event.target.getAttribute('data-url');
                    });
                }
                var allItemsContainers = document.getElementsByClassName('display-press-container');
                if (allItemsContainers.length > 1){
                    for (var w = 0; w < allItemsContainers.length; w++){
                        if (w > 0){
                            allItemsContainers[w].style.display = "none";
                        }
                        if (w === allItemsContainers.length - 1){
                            var buttonSeeMore = document.createElement('div');
                            buttonSeeMore.classList.add('button-see-more-press-container');
                            buttonSeeMore.innerHTML = '<button id="button-see-more-press">Afficher plus d\'articles</button>';
                            allItemsContainers[w].after(buttonSeeMore);
                        }
                    }
                }
                var buttonSeeMorePress = document.getElementById('button-see-more-press');
                if (buttonSeeMorePress){
                    buttonSeeMorePress.addEventListener('click', function(event){
                        for (var w = 0; w < allItemsContainers.length; w++){
                            allItemsContainers[w].style.display = "flex";
                        }
                        event.target.style.display = "none";
                    });
                }
            }
            /* MAP RESTAURANTS */
            if (body.classList.contains('home')){
                setTimeout(function(){
                    var image = "./wp-content/uploads/pin.png";
                    var restaurantsCoordinates = document.getElementsByClassName('restaurant-item-coordinates');
                    var lat = 46.448050;
                    var lon = 2.490176;
                    var map = new google.maps.Map(document.getElementById('map-restaurants'), {
                        center: {lat: lat, lng: lon},
                        zoom: 6,
                        disableDefaultUI: true,
                        styles: [
                            {
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "color": "#f5f5f5"
                                    }
                                ]
                            },
                            {
                                "elementType": "labels.icon",
                                "stylers": [
                                    {
                                        "visibility": "off"
                                    }
                                ]
                            },
                            {
                                "elementType": "labels.text.fill",
                                "stylers": [
                                    {
                                        "color": "#616161"
                                    }
                                ]
                            },
                            {
                                "elementType": "labels.text.stroke",
                                "stylers": [
                                    {
                                        "color": "#f5f5f5"
                                    }
                                ]
                            },
                            {
                                "featureType": "administrative.land_parcel",
                                "elementType": "labels.text.fill",
                                "stylers": [
                                    {
                                        "color": "#bdbdbd"
                                    }
                                ]
                            },
                            {
                                "featureType": "poi",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "color": "#eeeeee"
                                    }
                                ]
                            },
                            {
                                "featureType": "poi",
                                "elementType": "labels.text.fill",
                                "stylers": [
                                    {
                                        "color": "#757575"
                                    }
                                ]
                            },
                            {
                                "featureType": "poi.business",
                                "stylers": [
                                    {
                                        "visibility": "off"
                                    }
                                ]
                            },
                            {
                                "featureType": "poi.park",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "color": "#e5e5e5"
                                    }
                                ]
                            },
                            {
                                "featureType": "poi.park",
                                "elementType": "labels.text",
                                "stylers": [
                                    {
                                        "visibility": "off"
                                    }
                                ]
                            },
                            {
                                "featureType": "poi.park",
                                "elementType": "labels.text.fill",
                                "stylers": [
                                    {
                                        "color": "#9e9e9e"
                                    }
                                ]
                            },
                            {
                                "featureType": "road",
                                "stylers": [
                                    {
                                        "visibility": "off"
                                    }
                                ]
                            },
                            {
                                "featureType": "road",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "color": "#ffffff"
                                    }
                                ]
                            },
                            {
                                "featureType": "road.arterial",
                                "elementType": "labels.text.fill",
                                "stylers": [
                                    {
                                        "color": "#757575"
                                    }
                                ]
                            },
                            {
                                "featureType": "road.highway",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "color": "#dadada"
                                    }
                                ]
                            },
                            {
                                "featureType": "road.highway",
                                "elementType": "labels.text.fill",
                                "stylers": [
                                    {
                                        "color": "#616161"
                                    }
                                ]
                            },
                            {
                                "featureType": "road.local",
                                "elementType": "labels.text.fill",
                                "stylers": [
                                    {
                                        "color": "#9e9e9e"
                                    }
                                ]
                            },
                            {
                                "featureType": "transit.line",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "color": "#e5e5e5"
                                    }
                                ]
                            },
                            {
                                "featureType": "transit.station",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "color": "#eeeeee"
                                    }
                                ]
                            },
                            {
                                "featureType": "water",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "color": "#c9c9c9"
                                    }
                                ]
                            },
                            {
                                "featureType": "water",
                                "elementType": "labels.text.fill",
                                "stylers": [
                                    {
                                        "color": "#9e9e9e"
                                    }
                                ]
                            }
                        ]
                    });
                    var markers = [];
                    var infoWindows = [];
                    var loop = function ( r ) {
                        var id = restaurantsCoordinates[r].getAttribute('data-id');
                        var longitude = document.getElementById('long-' + id).innerText;
                        var latitude = document.getElementById('lat-' + id).innerText;
                        var name = document.getElementById('name-' + id).innerText;
                        var address = document.getElementById('address-' + id).innerText;
                        var url = document.getElementById('url-' + id).innerText;
                        var myLatlng = new google.maps.LatLng(latitude,longitude);
                        var marker = new google.maps.Marker({
                            position: myLatlng,
                            map: map,
                            icon: image
                        });
                        markers.push(marker);
                        var infowindow = new google.maps.InfoWindow({
                            content: "<strong>" + name + "</strong><br /><br />" + address
                        });
                        infoWindows.push(infowindow);
                        google.maps.event.addListener(marker, 'mouseover', function() {
                            infowindow.open(map,marker);
                        });
                        google.maps.event.addListener(marker, 'mouseout', function() {
                            infowindow.close(map,marker);
                        });
                        google.maps.event.addListener(marker, 'click', function() {
                            window.location.href = url;
                        });

                    };

                    for (var r = 0; r < restaurantsCoordinates.length; r++)loop( r );
                    google.maps.event.addListener(map, 'zoom_changed', function() {
                        var zoom = map.getZoom();
                        if (zoom >= 14){
                            for (var m = 0; m < markers.length; m++){
                                infoWindows[m].open(map,markers[m]);
                            }
                        }else {
                            for (var m$1 = 0; m$1 < markers.length; m$1++){
                                infoWindows[m$1].close(map,markers[m$1]);
                            }
                        }
                    });
                }, 2000);

            }
        }
    };

    window.elementorFrontend.elements.$window.one('elementor/frontend/init', function () {
        // Elementor frontend is loaded
        (function () {
            var Config = theme_config || {};
            Header.init();
        })();
    });

})));
//# sourceMappingURL=carte-sur-table.min.js.map
